import { Lugar } from './../../models/lugar.model';
import { Component } from '@angular/core';
import {  NavController, NavParams, Platform, MenuController } from 'ionic-angular';
import { BuscadorPage } from '../buscador/buscador';
import { VariablesGlobales } from '../../providers/variables-globales';

/**
 * Generated class for the LugarInteresPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-lugar-interes',
  templateUrl: 'lugar-interes.html',
})
export class LugarInteresPage {
  public lugar:Lugar;
  public lat_empresa: number;
  public long_empresa: number;
  public latitude:number;
  public longitude:number;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public platform: Platform,public menuCtrl:MenuController, public global: VariablesGlobales,) {
    this.lugar = this.navParams.get("lugar");
    this.convertUrlToCoordenates(this.lugar.mapa);
  }
  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
  compartir(){

  }
  goToNavigation(){

    let destination = this.lat_empresa + ',' + this.long_empresa;
    let origin = this.latitude+","+this.longitude;
      if(this.platform.is('ios')){
        window.open('maps://?q=' + destination, '_system');
      } else {
        window.open("https://www.google.es/maps/dir/"+origin+"/"+destination+"/")
      }
  }
  goToFile(file){
    window.open(VariablesGlobales.urlServidor + VariablesGlobales.lugaresPdfs + file);
  }
  ionViewDidLoad() {
    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position)=>{
        console.log(position.coords.latitude)
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
      });
    }
    console.log('ionViewDidLoad LugarInteresPage');
  }
  toggleMenu() {
    this.menuCtrl.toggle();
  }
  convertUrlToCoordenates(mapa){
    if(mapa) {
          if (mapa.includes("@")) {
              let aux = mapa.split("@");
              let aux2 = aux[1].split(",");
              this.lat_empresa = parseFloat(aux2[0]);
              this.long_empresa = parseFloat(aux2[1]);
          }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/lugar-interes/lugar-interes.ts